import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { IStore } from '../../reducers'
import { isLicenseValid } from '../../reducers/userAccount/selectors/license'
import PremiumBar, { IPremiumBarProps } from './PremiumBar'

const mapStateToProps = (state: IStore): IPremiumBarProps => ({
  licenseValid: isLicenseValid(state),
})

export default connect<any, any, any>(mapStateToProps)(
  withTranslation()(PremiumBar),
)
